import { action, runInAction, computed } from "mobx";
import { FieldType, ViewModelBase, observable } from "@shoothill/core";
import { AppUrls } from "AppUrls";
import { ProjectVisitorsListAndRelatedDTO, ProjectVisitorsListModel, ProjectVisitorsFormRequestDTO } from "./ProjectVisitorsListModel";

export class ProjectVisitorsListViewModel extends ViewModelBase<any> {
    @observable public projectId: string = "";
    @observable public visitorsListModels: ProjectVisitorsListModel[] = [];
    public constructor(projectId: string | null, date: any) {
        super();
        this.projectId = projectId!;
        this.model.createdDate = date.toISOString();
        this.loadVisitorsList();
    }

    @observable public errorMessage: string = "";

    @computed
    public get visitorsListItems() {
        return this.visitorsListModels.slice();
    }

    @action
    public loadVisitorsList = async (): Promise<void> => {
        this.setIsLoading(true);
        const request: ProjectVisitorsFormRequestDTO = {
            date: this.model.createdDate,
            projectId: this.projectId,
        };
        let apiResult = await this.Post<ProjectVisitorsListAndRelatedDTO>(
            AppUrls.Server.Projects.Construction.ProgrammeUpdates.CustomerVisitsSiteInstructions.GetVisitorsListByDate,
            request,
        );
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    this.visitorsListModels = [];
                    for (const visitor of apiResult.payload.siteAccessItems) {
                        let model = new ProjectVisitorsListModel();
                        model.fromDto(visitor);
                        this.visitorsListModels.push(model);
                    }
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
    };

    public async isFieldValid(fieldName: keyof FieldType<any>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);
        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
